import { render, staticRenderFns } from "./LayoutSplit.vue?vue&type=template&id=6b0df3fe&scoped=true&"
import script from "./LayoutSplit.vue?vue&type=script&lang=js&"
export * from "./LayoutSplit.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSplit.vue?vue&type=style&index=0&id=6b0df3fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0df3fe",
  null
  
)

export default component.exports